import { create } from 'zustand'

import type { SearchFilters } from '../../schemas/marketplace/filters'
import type { Profession } from '../../schemas/profession'

export type ActiveDropdown = 'profession' | 'where' | 'filters' | null

interface ActiveFilterStore {
  activeDropdown: ActiveDropdown
  setActiveDropdown: (dropdown: ActiveDropdown) => void
  selectedProfession: Profession | null
  setSelectedProfession: (profession: Profession | null) => void
  selectedLocation: string | null
  setSelectedLocation: (location: string | null) => void
  submittedFilters: SearchFilters
  setSubmittedFilters: (filters: SearchFilters) => void
  updateSubmittedFilters: (partialFilters: Partial<SearchFilters>) => void
  isUsingExactLocation: boolean
  setIsUsingExactLocation: (isUsingExactLocation: boolean) => void
  locationSearchInput: string
  setLocationSearchInput: (locationSearchInput: string) => void
  reset: () => void
}

const useActiveFilterStore = create<ActiveFilterStore>((set) => ({
  activeDropdown: null,
  setActiveDropdown: (dropdown) => set({ activeDropdown: dropdown }),
  selectedProfession: null,
  setSelectedProfession: (profession) => set({ selectedProfession: profession }),
  selectedLocation: null,
  setSelectedLocation: (location) => set({ selectedLocation: location }),
  submittedFilters: {},
  setSubmittedFilters: (filters) => set({ submittedFilters: filters }),
  updateSubmittedFilters: (partialFilters) =>
    set((state) => ({
      submittedFilters: { ...state.submittedFilters, ...partialFilters },
    })),
  isUsingExactLocation: false,
  setIsUsingExactLocation: (isUsingExactLocation) => set({ isUsingExactLocation }),
  locationSearchInput: '',
  setLocationSearchInput: (locationSearchInput) => set({ locationSearchInput }),
  reset: () =>
    set({
      selectedProfession: null,
      selectedLocation: null,
      submittedFilters: {},
      locationSearchInput: '',
      isUsingExactLocation: false,
      activeDropdown: null,
    }),
}))

export default useActiveFilterStore
